<template>
  <div v-show='data.hidden === false' class="col-sm-6 h-col-inputBoxSub">
    <div class='h-subscriber-inputLit'  v-if="data.showName !== ''">
      <div :id='data.id' class="h-subscriber-nocheck-style"><ejs-checkbox :ref="data.name+'Check'"></ejs-checkbox></div>
      <span v-show="getRequired" class="h-red-code">*</span>
      {{data.showName}}
    </div>
    <div class='h-subscriber-inputLit' v-if="data.showName === ''"></div>
    <div>
      <input :ref='data.name' :class="['e-control', 'e-textbox', 'e-lib', 'e-input',{ 'readonly-background': getReadonlyBackground}]" autoComplete="off" :maxlength='getMaxLength' :readonly='data.readonly' :disabled='data.disabled' :placeholder='data.placeholder' :name='data.name' v-model='params.paramVal' @click='clickFunc' @blur='blurFunc' @keyup="keyUpFunc"/>
    </div>
    <!--<button @click="getParams">Set Readonly</button>-->
  </div>
</template>
<script>
import common from '../common';

export default {
  name: 'Son_Text',
  props: [
    'data',
    'opCode',
    'setDataMethod'
  ],
  mixins: [common],
  data() {
    return {
      params: {
        name: this.data.name,
        paramVal: this.data.value
      },
      text: [
        'h-subscriber-inputBoxDiv',
        'h-subscriber-inputBoxDivInPartten1',
        'h-subscriber-inputBoxDivInPartten2'
      ],
      classText: 'h-subscriber-input'
    };
  },
  methods: {
    getParams() {
    },
  },
  created() {
    this.$parseInitData();
  },
};
</script>

<style scoped>

</style>
